define('drops/googlePlaces/googlePlaces',[
    'jquery',
    'when',
    'lq/drop',
    'lq/style',
    'lq/util'
], function ($, when, Drop, Style, util) {
    'use strict';

    function GooglePlaces(options) {
        Drop.call(this, $('<div/>'), options);

        this.data.eventing = util.convertListOfKeyValuesToObject(this.data.eventing);

        this.$input = $('<input type=text/>')
            .addClass('boxToBorderSize')
            .attr('name', this.data.name)
            .attr('tabindex', this.data.tabIndex)
			.attr('placeholder', this.data.watermark)
            .val(this.data.defaultValue || '')
            .css({
                width: '100%',
                height: '100%'
            })
            .appendTo(this.$element);

        Style.renderStyles(this, null, this.$input);

    };

    Drop.extend(GooglePlaces, Drop);

    GooglePlaces.typeName = 'GooglePlaces';

    GooglePlaces.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.applyPosition();
        this.formatter = this.piping.formatting.createFormatter(this.data.formatting);

        var deferred = when.defer();
        require([
                'google_maps'
            ],
            function() {
                deferred.resolve();
            });

        return deferred.promise;
    };

    GooglePlaces.prototype.postRender = function () {
        var searchBox = new google.maps.places.SearchBox(this.$input[0]);
        var self = this;
        var mapDrop = this.piping.dropFactory.findDropByName(this.data.targetDrop);
        if (mapDrop) {
            mapDrop.getMap().then(function(result) {
                if (result) {
                    result.addListener("bounds_changed", function() {
                        searchBox.setBounds(result.getBounds());
                    });
                }
            });
        }
        searchBox.addListener("places_changed", function() {
            var places = searchBox.getPlaces();
            if (places.length == 0) {
                return;
            }
            self.triggerEventIfEnabled('selected', places[0].formatted_address);
        });
    };

    GooglePlaces.prototype.getValue = function () {
        return this.$input.val();
    };

    GooglePlaces.prototype.clearValue = function () {
        this.$input.val('');
    };

    GooglePlaces.prototype.setValue = function (update) {
        var text = this.formatter.convertFromLicquidFormat(update.type, update.value);
        this.$input.val(text);
    };

    return GooglePlaces;
});
